<template>
    <div>
        <el-dialog :title="title" top="5%" size="tiny" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="考勤年月" prop="months">
               <el-date-picker type="month" placeholder="选择日期" v-model="form.months"  style="width: 100%"></el-date-picker>
                </el-form-item>   
                <el-form-item label="上传Excel">
                    <sy-doc-upload v-model="form.FFileName" ></sy-doc-upload>
                </el-form-item>
            </el-form>
            <div class="download">
                <a href="javascript:;" @click="download()">下载模板</a>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button v-if="authEdit" type="primary" @click="save" :loading="loading">导入</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data() {
            return {
                title:"",
                authEdit:true,
                form: {},
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            _open(record) {
                this.title = "导入数据"
                this.editFormVisible = true;
                let form = {FID:0,FFileName:"",months:''};
                this.form = Object.assign(form,record);
              
            },
            save:function () {
              if(this.form.months==""){
                util.msgWarning("请选择考勤年月")
                return
              }
              if(this.form.FFileName==""){
                util.msgWarning("请上传要导入的文件")
                return
              }
                let url = "server/business/Attendance.ashx?cmd=ImportExcel"
                util.saveForm(url,this.$refs.form,this.form,this.loadFn("loading"),result=> {
                    util.msgSuc("导入成功")
                    this.editFormVisible = false
                    this.$emit("onImportSuc",this.form)
                })
            },
            download(){
                window.open(global.serverHost+ "client/attendance_import.xlsx")
            }
        },
        created() {

        }
    }
</script>


<style scope>
    .download{
        margin: 20px 120px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/business/Attendance_Import.vue